import React, { useCallback, useState } from "react";
import { observer } from "mobx-react-lite";
import { TextArea } from "../TextArea";
import { useFormContext } from "../Form";
export const PlainTextEditor = observer(({ name, customControls, onChange, onBlur }) => {
    const [selection, setSelection] = useState({ start: 0, end: 0 });
    const { values } = useFormContext();
    const editorElement = {
        selection: {
            focus: () => { },
            insertHTML: (text) => {
                if (selection.start === null || selection.end === null)
                    return;
                const currentText = values[name];
                const left = currentText.substring(0, selection.start);
                const right = currentText.substring(selection.end, currentText.length);
                const newText = `${left}${text}${right}`;
                values.set(name, newText);
                setSelection({ start: left.length, end: left.length + text.length });
            },
        },
    };
    const onTextAreaChange = useCallback((e) => {
        setSelection({
            start: e.target.selectionStart,
            end: e.target.selectionEnd,
        });
    }, []);
    const onTextAreaBlur = useCallback((e) => {
        setSelection({
            start: e.target.selectionStart,
            end: e.target.selectionEnd,
        });
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "jodit-container jodit jodit_theme_piston" },
            React.createElement("div", { className: "jodit-toolbar__box" },
                React.createElement("div", { className: "jodit-toolbar-editor-collection jodit-toolbar-editor-collection_mode_horizontal jodit-toolbar-editor-collection_size_middle" },
                    React.createElement("div", { className: "jodit-ui-group jodit-ui-group_line_true jodit-ui-group_size_middle" },
                        React.createElement("div", { className: "jodit-ui-group jodit-ui-group_size_middle" },
                            React.createElement("span", { className: "jodit-toolbar-button jodit-toolbar-button_size_middle jodit-toolbar-button_variant_initial jodit-toolbar-button_M jodit-toolbar-button_text-icons_true jodit-ui-group__M", role: "listitem" }, customControls.map((c) => (React.createElement("button", { className: "jodit-toolbar-button__button", type: "button", onClick: () => c.onClick(editorElement), key: c.name },
                                React.createElement("span", { className: "jodit-toolbar-button__text" }, c.label))))))))),
            React.createElement("div", { className: "jodit-workplace" },
                React.createElement(TextArea, { label: "", name: name, style: {
                        backgroundColor: "#fff",
                        color: "#111",
                        padding: "10px",
                        maxWidth: "100%",
                        minWidth: "100%",
                    }, onChange: onChange, onBlur: onBlur, rawOnChange: onTextAreaChange, rawOnBlur: onTextAreaBlur })),
            React.createElement("div", { className: "jodit-status-bar" },
                React.createElement("div", { className: "jodit-status-bar__item jodit-status-bar__item-right" }, values && values[name] !== null && (React.createElement("span", null,
                    "Chars: ",
                    values[name]?.length)))))));
});
